// ------------------------------------------------------------------------------
// <auto-generated>
// This code was generated by the @augloop/code-gen tool.
// Source: https://dev.azure.com/office/ISS/_git/augloop-server?path=%2Fmodules%2Ftypes-text%2Fsrc%2Ftiles.ts
// Changes to this file may cause incorrect behavior and will be lost upon regeneration.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Alignment, IDateTile, IDynamicTextContext, IFormattedRange, IFormattedTextTile, IObjectReference, IPersonTile, ITaskTile, ITextTile, ListType } from '../tiles';
import { SchemaObject, SchemaObjectHeader } from '@augloop/types-core';

export class TextTile implements ITextTile {
    public readonly content: string;
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: ITextTile) {
        SchemaObject.assign(TextTile, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Text_TextTile';
    }
    public static getBaseTypes(): string[] {
        return [];
    }
    public static readonly H_ = { T_: TextTile.getTypeName(), B_: TextTile.getBaseTypes() };
}

export class FormattedTextTile implements IFormattedTextTile {
    public readonly indentation?: number;
    public readonly outlineLevel?: number;
    public readonly listType?: ListType;
    public readonly alignment?: Alignment;
    public readonly formattedRanges?: IFormattedRange[];
    public readonly isInsideTable?: boolean;
    public readonly isInsideTOC?: boolean;
    public readonly objectReferences?: IObjectReference[];
    public readonly spacingBeforeParagraph?: number;
    public readonly spacingAfterParagraph?: number;
    public readonly lineSpacing?: number;
    public readonly rightIndentation?: number;
    public readonly listId?: string;
    public readonly bulletAndNumberFontSize?: number;
    public readonly bulletAndNumberFontFamily?: string;
    public readonly content: string;
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: IFormattedTextTile) {
        SchemaObject.assign(FormattedTextTile, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Text_FormattedTextTile';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Text_TextTile'];
    }
    public static readonly H_ = { T_: FormattedTextTile.getTypeName(), B_: FormattedTextTile.getBaseTypes() };
}

export class DynamicTextContext implements IDynamicTextContext {
    public contextAbove?: ITextTile[];
    public contextBelow?: ITextTile[];
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: IDynamicTextContext) {
        SchemaObject.assign(DynamicTextContext, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Text_DynamicTextContext';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Core_DynamicContext'];
    }
    public static readonly H_ = { T_: DynamicTextContext.getTypeName(), B_: DynamicTextContext.getBaseTypes() };
}

export class TaskTile implements ITaskTile {
    public readonly indentation?: number;
    public readonly outlineLevel?: number;
    public readonly listType?: ListType;
    public readonly alignment?: Alignment;
    public readonly formattedRanges?: IFormattedRange[];
    public readonly isInsideTable?: boolean;
    public readonly isInsideTOC?: boolean;
    public readonly objectReferences?: IObjectReference[];
    public readonly spacingBeforeParagraph?: number;
    public readonly spacingAfterParagraph?: number;
    public readonly lineSpacing?: number;
    public readonly rightIndentation?: number;
    public readonly listId?: string;
    public readonly bulletAndNumberFontSize?: number;
    public readonly bulletAndNumberFontFamily?: string;
    public readonly content: string;
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: ITaskTile) {
        SchemaObject.assign(TaskTile, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Text_TaskTile';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Text_FormattedTextTile', 'AugLoop_Text_TextTile'];
    }
    public static readonly H_ = { T_: TaskTile.getTypeName(), B_: TaskTile.getBaseTypes() };
}

export class PersonTile implements IPersonTile {
    public readonly upn: string;
    public readonly content: string;
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: IPersonTile) {
        SchemaObject.assign(PersonTile, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Text_PersonTile';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Text_TextTile'];
    }
    public static readonly H_ = { T_: PersonTile.getTypeName(), B_: PersonTile.getBaseTypes() };
}

export class DateTile implements IDateTile {
    public readonly timestamp: number;
    public readonly content: string;
    public readonly H_: SchemaObjectHeader;
    public constructor(obj?: IDateTile) {
        SchemaObject.assign(DateTile, this, obj);
    }
    public static getTypeName(): string {
        return 'AugLoop_Text_DateTile';
    }
    public static getBaseTypes(): string[] {
        return ['AugLoop_Text_TextTile'];
    }
    public static readonly H_ = { T_: DateTile.getTypeName(), B_: DateTile.getBaseTypes() };
}

